import { InputDate } from './types/inputDate'

// A rudimentary util, to be improved when needed (e.g. parsing string values)

// We return undefined and not e.g. null, because formatting undefined will
// produce "now", and with null it'll be '01/01/1970'
export const parseToDate = (input?: InputDate): Date | undefined => {
  if (!input) {
    return undefined
  }

  if (input instanceof Date && !isNaN(input.getTime())) {
    return input
  }

  if (typeof input === 'number' || typeof input === 'string') {
    const date = new Date(input)

    if (!isNaN(date.getTime())) {
      return date
    }
  }

  return undefined
}
